module.exports = __webpack_public_path__ + "static/media/landing-slide-4.2fe1219b.png";